import { CustomConnectorConnectionToggle, CustomConnectorDestinationItem } from '@/features/destinations/components/customConnectors';
import { CustomConnectorDto } from '@/models/connectors';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type DataCatalogDestinationGridProps = {
  customConnectors?: CustomConnectorDto[];
  className?: string;
};

export const DataCatalogDestinationGrid: FC<DataCatalogDestinationGridProps> = ({ customConnectors = [], className }) => {
  const { t } = useTranslation('COMMON');

  const [connectedCustomConnectors, disconnectedCustomConnectors] = useMemo(() => {
    return customConnectors.reduce(
      ([connected, disconnected], connector) => {
        const isConnected = connector.isAuthenticated;
        return isConnected ? [[...connected, connector], disconnected] : [connected, [...disconnected, connector]];
      },
      [[], []]
    );
  }, [customConnectors]);
  return (
    <div className='flex flex-col'>
      <p className='p-4 text-base font-semibold text-brand-600 first-letter:uppercase'>{t('highlighted')}</p>

      {connectedCustomConnectors.length > 0 && (
        <div className={twMerge(`flex flex-wrap gap-4 justify-start pt-2 pb-4`, className)}>
          {connectedCustomConnectors.map((connector) => (
            <CustomConnectorDestinationItem key={connector.id} connector={connector}>
              <CustomConnectorConnectionToggle connector={connector} deauthenticateDisabled={false} />
            </CustomConnectorDestinationItem>
          ))}
        </div>
      )}

      <div className={twMerge(`flex flex-wrap gap-4 justify-star pt-4 pb-2 border-t`, className)}>
        {disconnectedCustomConnectors.map((connector) => (
          <CustomConnectorDestinationItem key={connector.id} connector={connector}>
            <CustomConnectorConnectionToggle connector={connector} deauthenticateDisabled={false} />
          </CustomConnectorDestinationItem>
        ))}
      </div>
    </div>
  );
};
